import { MobileMenuDialogMenuCountryProps } from '@/types/props/components/layout';
import { ImagesHeaderChevronLeftSvg } from '@/assets/images_header.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import DefaultLink from '@/components/common/default/DefaultLink';
import { createCountyOfOriginUrl } from '@/utilites/algolia/create-algolia-urls';
import { Transition } from '@headlessui/react';
import Image from 'next/image';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { HeaderEnum } from '@/types/translations/HeaderEnum';

export default function MobileMenuDialogMenuCountry({
  currentSubMenuActive,
  setCurrentSubMenuActive,
}: MobileMenuDialogMenuCountryProps) {
  const { translate } = useTypedTranslation<HeaderEnum>('header');

  return (
    <Transition
      show={currentSubMenuActive === 'countries'}
      enter="tw-transition-transform tw-duration-150"
      enterFrom="tw-transform tw--translate-x-full"
      enterTo="tw-transform tw-translate-x-0"
      leave="tw-transition-transform tw-duration-150"
      leaveFrom="tw-transform tw-translate-x-0"
      leaveTo="tw-transform tw--translate-x-full"
      as={'div'}
    >
      <ul className="tw-p-0 tw-list-none tw-pt-5 tw-flex tw-flex-col tw-gap-4 tw-border tw-border-solid tw-border-platinum-gray tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-pb-4">
        <li>
          <DefaultButton
            className="tw-pl-1 tw-font-plusJakartaSans tw-font-medium tw-text-sm tw-leading-[20.16px] tw-text-textBlack tw-flex tw-items-center tw-gap-4 tw-w-full nine:tw-min-w-[unset] tw-shadow-sm tw-pb-2 max-nine:!tw-text-sm"
            onClick={() => setCurrentSubMenuActive('none')}
          >
            <Image
              src={ImagesHeaderChevronLeftSvg}
              width={6}
              height={12}
              alt="chevron right"
            />
            {translate(HeaderEnum['mobile_menu.buy_spirits.countries'])}
          </DefaultButton>
        </li>
        <li>
          <DefaultLink
            className="tw-font-plusJakartaSans tw-font-medium tw-text-sm tw-leading-[20.16px] tw-text-textBlack tw-flex tw-items-center tw-justify-between tw-w-full nine:tw-min-w-[unset] max-nine:!tw-text-sm"
            href={createCountyOfOriginUrl('Scotland')}
          >
            {translate(HeaderEnum['mobile_menu.countries.scotland'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-font-plusJakartaSans tw-font-medium tw-text-sm tw-leading-[20.16px] tw-text-textBlack tw-flex tw-items-center tw-justify-between tw-w-full nine:tw-min-w-[unset] max-nine:!tw-text-sm"
            href={createCountyOfOriginUrl('France')}
          >
            {translate(HeaderEnum['mobile_menu.countries.france'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-font-plusJakartaSans tw-font-medium tw-text-sm tw-leading-[20.16px] tw-text-textBlack tw-flex tw-items-center tw-justify-between tw-w-full nine:tw-min-w-[unset] max-nine:!tw-text-sm"
            href={createCountyOfOriginUrl('Japan')}
          >
            {translate(HeaderEnum['mobile_menu.countries.japan'])}
          </DefaultLink>
        </li>
      </ul>
    </Transition>
  );
}
